export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const ADD_PRODUCT = "ADD_PRODUCTS";
export const REMOVE_PRODUCT = "REMOVE_PRODUCTS";
export const ADJUST_QUANTITY = "ADJUST_PRODUCTS";
